import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';

import { CardComponent } from '../card/card.component';

@Component({
  selector: 'lyceo-notification-alert',
  imports: [CardComponent],
  templateUrl: './notification-alert.component.html',
  styleUrls: ['./notification-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationAlertComponent {
  public notificationTitle: InputSignal<string> = input.required<string>();
  public notificationText: InputSignal<string | undefined> = input();
}
